import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';

import './externals/hamburgers.js';
import './externals/flickity';

import Map from './sections/googleMaps';
new Map();
